import {
  adaptPropertiesWave2,
  adaptPropertiesWave3,
  adaptPropertiesWave4,
  adaptPropertiesWave5,
  adaptPropertiesWave6,
  adaptPropertiesWave7
} from 'stores/adapters/bex-api/migration-adapters/search/properties';
import {
  BffResponseRetrofitAdapter,
  MigrationExperimentMapping,
  PropertyMigrationAdapter,
  SearchMigrationAdapter
} from 'stores/adapters/bex-api/migration-adapters';
import { adaptAnalytics } from 'stores/adapters/bex-api/migration-adapters/search/analytics';
import { adaptInsights } from 'stores/adapters/bex-api/migration-adapters/search/insights';
import { adaptMapAndProperties, adaptRolledOutSpinnerData } from 'stores/adapters/bex-api/migration-adapters/search/map-and-properties';
import { adaptResultsSummary } from 'stores/adapters/bex-api/migration-adapters/search/results-summary-messages';
import { adaptReviews } from 'stores/adapters/bex-api/migration-adapters/search/properties';
import { adaptSortAndFilters } from 'stores/adapters/bex-api/migration-adapters/search/sort-and-filter';
import { splitMessagesFromLodging } from 'stores/adapters/bex-api/migration-adapters/search/bff-messages-retrofit';

// Key/value pairs of experiment names and their associated adapters.
export const searchMigrationExperimentMapping: MigrationExperimentMapping = {
  Badges_Attributes_wave_6_shopping_pwa_mm_bex_api_lodging: adaptPropertiesWave6,
  shopping_pwa_mm_bex_api_lodging_properties_baseline: adaptMapAndProperties,
  shopping_pwa_mm_bex_api_lodging_properties_wave_2: adaptPropertiesWave2,
  pricing_srp_wave_3_shopping_pwa_mm_bex_api_lodging: adaptPropertiesWave3,
  infosite_urls_wave_4_shopping_pwa_mm_bex_api_lodging: adaptPropertiesWave4,
  shortlist_wave_5_shopping_pwa_mm_bex_api_lodging: adaptPropertiesWave5,
  shopping_pwa_mm_bex_api_lodging_map_and_properties: adaptRolledOutSpinnerData,
  shopping_pwa_mm_bex_api_lodging_analytics: adaptAnalytics,
  srp_insights_shopping_pwa_mm_bex_api_lodging: adaptInsights,
  primary_card_messages_wave_7_shopping_pwa_mm_bex_api_lodging: adaptPropertiesWave7
};

// Adapters here to stay. Taken out of `searchMigrationExperimentMapping` and put in this list,
// after parity has been established in testing.
export const searchMigrationAdapters: SearchMigrationAdapter[] = [adaptResultsSummary, adaptSortAndFilters];

export const propertyMigrationAdapters: PropertyMigrationAdapter[] = [adaptReviews];

export const bffResponseRetrofitAdapters: BffResponseRetrofitAdapter[] = [splitMessagesFromLodging];
